import { Reason } from './HireReasons.styles'
import { HireReason as HireReasonType } from 'types/hire-reason'
import { generateReasonWithLinks } from 'utils/generalUtils'
import { Heading } from '@careguide/typography'
import Stack from '@careguide/stack'

type HireReasonProps = {
  hireReasons: Array<HireReasonType>
}

const HireReason = ({ hireReasons }: HireReasonProps) => {
  return (
    <Stack gap='3'>
      <Heading as='h2'>Reasons to Hire Me</Heading>
      <ul>
        {hireReasons.map((hireReason, index) => (
          <Reason
            key={index}
            dangerouslySetInnerHTML={{ __html: generateReasonWithLinks(hireReason) }}
          />
        ))}
      </ul>
    </Stack>
  )
}

export default HireReason
